import {
  Button,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  LoadingSm,
  RequirementBadge,
} from "@medimo/ui";
import {
  type SignUpFormSchemaType,
  useSignUpForm,
} from "../../hooks/use-sign-up-form";
import { PasswordInput } from "../password-input";

type SignUpFormProps = {
  isPending: boolean;
  defaultValues: SignUpFormSchemaType;
  errorMessage?: string | null;
  termsOfUseHref: string;
  privacyPolicyHref: string;
  onSignUpSubmit?: VoidFunction;
  onSuccess?: (result: { email: string }) => void;
};

export const SignUpForm = ({
  isPending,
  defaultValues,
  errorMessage,
  termsOfUseHref,
  privacyPolicyHref,
  onSignUpSubmit,
  onSuccess,
}: SignUpFormProps) => {
  const { form, handleSubmit, isLoading } = useSignUpForm({
    defaultValues,
    onMutation: onSignUpSubmit,
    onSuccess,
  });

  return (
    <Form {...form}>
      <form className="space-y-6" onSubmit={handleSubmit}>
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="flex items-center gap-2">
                メールアドレス
                <RequirementBadge required />
              </FormLabel>
              <FormControl>
                <Input
                  autoComplete="email"
                  placeholder="example@hospital.jp"
                  {...field}
                  onBlur={() => {
                    field.onChange(field.value.trim());
                    field.onBlur();
                  }}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="password"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="flex items-center gap-2">
                パスワード
                <RequirementBadge required />
              </FormLabel>
              <FormControl>
                <PasswordInput
                  autoComplete="new-password"
                  type="password"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormMessage>{form.formState.errors.root?.message}</FormMessage>
        <FormMessage>{errorMessage}</FormMessage>
        <div className="space-y-4">
          <p className="text-center text-base text-foreground leading-relaxed">
            「アカウントを作成」をタップすると、
            <a
              className="text-primary underline"
              href={termsOfUseHref}
              rel="noreferrer"
              target="_blank"
            >
              利用規約
            </a>
            および
            <a
              className="text-primary underline"
              href={privacyPolicyHref}
              rel="noreferrer"
              target="_blank"
            >
              プライバシーポリシー
            </a>
            に同意したものとみなします
          </p>
          <Button
            className="flex w-full gap-3"
            disabled={isPending || isLoading}
            type="submit"
          >
            {isPending || isLoading ? <LoadingSm /> : "アカウントを作成"}
          </Button>
        </div>
      </form>
    </Form>
  );
};
